import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import { showNotificationMessage } from 'src/actions'
import { useHistory } from 'react-router-dom'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import keycloak from 'src/utils/commonMethods/keycloak'
import { buyPolicyJourney } from 'src/services/buyPolicy'

const InsuredMembersAgeSelector = ({ handleClose, formValues }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const lifeReducerData = useSelector((state) => state?.buyPolicyLifeReducer)

  // eslint-disable-next-line
  const [ageDetails, setAgeDetails] = useState({})
  // eslint-disable-next-line
  const [errorDetails, setErrorDetails] = useState({})

  const updateAgeDetails = () => {
    let updatedAgeDetails = {}
    lifeReducerData?.userDetails?.insuredMembers?.forEach((member) => {
      updatedAgeDetails[member?.value] = ''
    })

    setAgeDetails(updatedAgeDetails)
    setErrorDetails(updatedAgeDetails)
  }

  useEffect(() => {
    updateAgeDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lifeReducerData])

  // const handleAgeDetailsChange = (event, key) => {
  //   setAgeDetails({
  //     ...ageDetails,
  //     [key]: event?.target?.value,
  //   })
  // }

  // const calculateMaxDate = () => {
  //   const today = new Date()
  //   return `${today?.getFullYear()}-${(today?.getMonth() + 1)
  //     ?.toString()
  //     ?.padStart(2, '0')}-${today?.getDate()?.toString()?.padStart(2, '0')}`
  // }

  // const validateAgeDetails = () => {
  //   let isValid = true
  //   Object.keys(ageDetails)?.forEach((age) => {
  //     if (!ageDetails[age]) {
  //       setErrorDetails({
  //         ...errorDetails,
  //         [age]: 'Please enter the Date of Birth',
  //       })
  //       isValid = false
  //     }
  //   })

  //   return isValid
  // } might be future development

  const handleProceed = async () => {
    const submissionData = {
      ...formValues,
      mobile: formValues?.mobileNumber,
      insuredRelation: formValues?.insuredRelation?.map((item) => {
        return item?.value
      }),
    }
    const response = await buyPolicyJourney(keycloak?.token, submissionData)

    if (response?.message) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.INFO,
          message: response?.message,
        })
      )
      history.push('/individual/dashboard/')
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.titleContainer}>
        <div className={classes.title}>confirmation</div>
        <div className={classes.closeButtonContainer}>
          <IconButton onClick={handleClose} id='closeNoPrefilledDataButton'>
            <CloseIcon />
          </IconButton>
        </div>
      </div>

      <div className={classes.mainContainer}>
        <h5 className={classes.submissionHeading}>Are you sure to submit</h5>

        {/* <Grid container spacing={2}>
          {lifeReducerData?.userDetails?.insuredMembers?.map((member) => {
            return (
              <Grid item xs={12} xl={12} key={`ageDetails__${member.value}`}>
                <div className={classes.formControlRow}>
                  <span className={classes.formControlLabel}>{member.label}</span>
                  <FormControl fullWidth>
                    <TextField
                      id='ageDetails'
                      name='ageDetails'
                      type='text'
                      placeholder='Date Of Birth *'
                      onFocus={(e) => {
                        e.currentTarget.type = 'date';
                      }}
                      onBlur={(e) => {
                        e.currentTarget.type = e.target.value ? 'date' : 'text';
                      }}
                      value={ageDetails[member.value] ?? ''}
                      onChange={(event) => handleAgeDetailsChange(event, member.value)}
                      InputLabelProps={{}}
                      size='small'
                      InputProps={{
                        className: classes.inputField,
                        endAdornment: (
                          <InputAdornment position='end'>
                            <Button className={classes.ageButton}>
                              <span className={classes.ageText}>
                                Age:{getAge(ageDetails[member.value])}
                              </span>
                            </Button>
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        max: calculateMaxDate(),
                      }}
                      error={!!errorDetails[member.value]}
                      helperText={errorDetails[member.value]}
                    />
                  </FormControl>
                </div>
              </Grid>
            );
          })}
        </Grid> */}
        {/* component will be needed when development takes place on this particular flow  */}
      </div>

      <div className={classes.actionsContainer}>
        <Button
          variant='outlined'
          className={classes.cancelButton}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant='container'
          className={classes.proceedButton}
          onClick={handleProceed}
        >
          Proceed
        </Button>
      </div>
    </div>
  )
}

export default InsuredMembersAgeSelector

const useStyles = makeStyles({
  root: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
  },
  titleContainer: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    padding: '10px 0',
    borderBottom: '1px solid #ddd',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontWeight: '500',
    fontSize: '18px',
  },
  closeButtonContainer: {
    position: 'absolute',
    right: '0px',
  },
  mainContainer: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'column',
  },
  submissionHeading: {
    width: '100%',
    textAlign: 'center',
  },
  formControlRow: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    gap: '20px',
    alignItems: 'center',
  },
  formControlLabel: {
    fontSize: '14px',
    fontWeight: '500',
    display: 'flex',
    minWidth: '50%',
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    justifyContent: 'center',
    marginTop: '20px',
  },
  cancelButton: {
    borderColor: '#4dc3e3 !important',
    color: '#4dc3e3 !important',
  },
  proceedButton: {
    backgroundColor: `${COLORS.DARK_PINK} !important`,
    color: '#ffffff !important',
  },
})
